import _ from "lodash";

import { IFormlyConfig, ITypeOptions } from "AngularFormly";
export * from "./controller";
import { RecordSelectAsyncController } from "./controller";

export function recordSelectAyncConfig(formlyConfigProvider: IFormlyConfig) {
  const gridType: ITypeOptions = {
    name: "recordGridSelectAsync",
    wrapper: ["bootstrapHasError"],
    template: require("!html-loader!./index.html").default,
    controller: RecordSelectAsyncController,
  };
  formlyConfigProvider.setType(gridType);

  const type: ITypeOptions = {
    ...gridType,
    name: "recordSelectAsync",
    wrapper: ["bootstrapLabel", "bootstrapHasError"],
  };
  formlyConfigProvider.setType(type);
}
recordSelectAyncConfig.$inject = ["formlyConfigProvider"];
